import React, { useState } from 'react';
import { makeStyles, TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import Avatar from '@material-ui/core/Avatar';

const useStyles = makeStyles((theme) => ({
  avatar: {
    marginRight: '10px',
  },
  root: {
    [theme.breakpoints.down('sm')]: {
      width: '200px',
    },
    [theme.breakpoints.up('md')]: {
      width: '300px',
    },
  },
}));
export const AutoCompleteInput = ({ options, optionHandler }) => {
  const classes = useStyles();
  return (
    <Autocomplete
      id="auto-complete"
      className={classes.root}
      options={options as optionType[]}
      autoHighlight
      getOptionLabel={(option) => option.name}
      onChange={(event, newValue) => optionHandler(newValue)}
      renderOption={(option) => (
        <React.Fragment>
          <span>
            <Avatar alt="Profile" src={option.dp} className={classes.avatar} />
          </span>
          {option.name}
        </React.Fragment>
      )}
      renderInput={(params) => <TextField {...params} label="Name" variant="standard" />}
    />
  );
};
interface optionType {
  name: string;
  dp: string;
}
